export default __webpack_public_path__ + "assets/checked-blue-icon.ab514b.svg";